/**
 * Hand-written counterparts to the generated types.
 *
 * Everything the OpenAPI spec describes is generated into src/api/generated and must not be
 * duplicated here. This file is only for what the spec does not carry: the error body (no
 * endpoint declares it as a response) and the error codes the UI branches on.
 */

/**
 * The backend's error wire codes the UI branches on (its `ErrorCode` enum). Branch on these,
 * never on the summary text, which is free to change.
 */
export const ErrorCodes = {
  /** No session, or the code entered at sign-in was wrong. */
  UNAUTHORIZED: 'AUTHN_003',
  VALIDATION_FAILED: 'SERVICE_001',
  NOT_FOUND: 'SERVICE_005',
  /** Unique per vendor: a customer's phone, a linked POS order ID. */
  DUPLICATE_ENTRY: 'SERVICE_007',
  RATE_LIMITED: 'SERVICE_009',
  UNEXPECTED: 'SYS_001',
} as const;

/** Every error response: a stable code, a human summary, and the request's trace id. */
export interface ErrorData {
  code: string;
  summary: string;
  /** The request's correlation id, also in the `X-Correlation-Id` header. */
  traceId?: string;
  timestamp?: string;
  /** Field validation messages, joined, when there are any. */
  details?: string;
}

/**
 * A normalised error, whatever layer produced it - RTK Query, axios, or a network failure
 * with no response at all.
 */
export interface NormalisedError {
  /** A backend wire code, or NETWORK_ERROR when no response arrived at all. */
  code: string;
  message: string;
  details?: string;
  /** Quote this in a support ticket; it ties the failure to the server log. */
  correlationId?: string;
  status?: number;
}
